import { render, staticRenderFns } from "./DetailInvoiceGold.vue?vue&type=template&id=08901414&"
import script from "./DetailInvoiceGold.vue?vue&type=script&lang=js&"
export * from "./DetailInvoiceGold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports